import {RendererProps} from './RendererProps';

/**
 * @about Discriminated unions with "type" and "renderer" discriminant
 */
export type Schema = RendererProps;
